import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Member/';

const state = {
  IntegralNo_Type: {
    TeamOrderPay: "团队订单支付",
    ShoppingMallOrderPay: "商城订单支付",
    MemberSignIn: "会员签到",
    MemberRegister: "会员注册",
    TeamEvaluate: "团队评价",
  }
};

const mutations = {};

const actions = {
  SignIn({commit}, view) {
    return request.PromiseCall(basePath, 'SignIn', view);
  },
  MemberTodaySignIn({commit}, view) {
    return request.PromiseCall(basePath, 'MemberTodaySignIn', view);
  },
  CheckIntegralLogByMemberId({commit}, view) {
    return request.PromiseCall(basePath, 'CheckIntegralLogByMemberId', view);
  },
  Edit({commit}, view) {
    return request.PromiseCall(basePath, 'Edit', view);
  },
  GetFollowSysUserRoleCount({commit}, view) {
    return request.PromiseCall(basePath, 'GetFollowSysUserRoleCount', view);
  },
  MyMember({commit}, view) {
    return request.PromiseCall(basePath, 'MyMember', view);
  },
  GetFans({commit}, view) {
    return request.PromiseCall(basePath, 'GetFans', view);
  },
  Get({commit}, view) {
    return request.PromiseCall(basePath, 'Get', view);
  }

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Member/index.js